import { AbstractControl, Validator, ValidationErrors, NG_VALIDATORS, ValidatorFn, FormGroup } from "@angular/forms";
import { Directive } from "@angular/core";

@Directive({
  selector: '[appValidateTextNotificationData]',
  providers: [{ provide: NG_VALIDATORS, useExisting: TextNotificationhValidatorDirective, multi: true }]
})

export class TextNotificationhValidatorDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    return TextNotificationValidator(control);
  }
}


export const TextNotificationValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const mobilePhone = control.get('contact_Mobile')?.value;
  const email = control.get('contact_Email')?.value;
  const recievesNotifications = control.get('contact_receivesNotifications')?.value;


  const notificationType = control.get('notificationDelivery')?.value;

  let valid = null;

  if (recievesNotifications) {
    valid = (notificationType === null || notificationType === "") ? { deliveryOptionInvalid: true } : null;
  }

  if (notificationType === 'Both') {
    valid = ((mobilePhone === null || mobilePhone === "") || (email === null || email === "")) ?{ notificationDataInvalid: true }: null;
  }

  if (notificationType === 'Text') {
    valid = (mobilePhone === null || mobilePhone === "") ? { mobilePhoneInvalid: true } : null;
  }

  if (notificationType === 'Email') {
    valid = (email === null || email === "") ? { emailPhoneInvalid: true } : null;
  }

  return valid;
};
